module.exports = __webpack_public_path__ + "img/jh.fc686199.jpg";